import * as React from 'react';
import * as Redux from 'redux';
import * as ReactCreateClass from 'create-react-class';
import { IDropdownOption } from '../../../state-helpers/filters';

export interface IDropdownSelectProps {
    values: IDropdownOption[];
    display?: string;
    placeHolder?: string;
    onDropdownSelect: (id: string | number) => void;
    name?: string;
    disabled?: boolean;
    id?: string;
    dropdownLabel?: string;
    testID?: string;
}

export interface IDropdownOptionProps {
    value: IDropdownOption;
    onDropdownSelect: () => void;
    name?: string
}

export class DropdownSelect extends React.Component<IDropdownSelectProps, any> {
    readonly PINNED = "#pinned#";

    containerNode: Node;

    static defaultProps = {
        placeHolder: '',
        display: '',
    }

    constructor(props) {
        super(props);
    }

    handleChange = (event) => {
        this.props.onDropdownSelect(event.target.value);
    }

    get selectedValue() {
        let value = this.props.values.filter(v => v.selected)[0];

        return value ? value.id : '';
    }

    getId = (option: IDropdownOption) => {
        // Pinned items need to have unique ids since they will be duplicated in the list
        if (option.isPinned)
            return option.id + this.PINNED;

        return option.id;
    }

    get renderLabel() {
        if (!this.props.dropdownLabel) {
            return;
        }

        return (
            <h5>
                {this.props.dropdownLabel}
            </h5>
        );
    }

    render() {
        return (
            <React.Fragment>
                {this.renderLabel}
                <select
                    id={this.props.id}
                    value={this.selectedValue}
                    className="select-value"
                    onChange={this.handleChange}
                    disabled={this.props.disabled}
                    data-testid={this.props.testID}>
                    {
                        this.props.values.map(
                            (value, index) => (
                                <option value={value.id} key={this.getId(value) + index} disabled={value.isDisabled}>{value.display}</option>
                            ))
                    }
                </select>
            </React.Fragment>
        )
    }
}